/**
 * Typed, validated access to the handful of build-time variables the browser is
 * allowed to see. Reading `import.meta.env` directly all over the app makes a
 * missing variable a silent `undefined`; funnelling it here makes it loud.
 */
const env =
  typeof import.meta !== 'undefined' && import.meta.env
    ? import.meta.env
    : typeof process !== 'undefined' && process.env
      ? process.env
      : {};

const getEnv = (key, fallback = '') => {
  const value = env[key];
  return value || fallback;
};

export const config = {
  apiUrl: getEnv('VITE_API_URL', 'http://localhost:5000/api/v1'),
  siteUrl: env.VITE_SITE_URL ?? (typeof window !== 'undefined' ? window.location?.origin : 'http://localhost:5173'),
  captcha: {
    provider: env.VITE_CAPTCHA_PROVIDER ?? 'none',
    siteKey: env.VITE_CAPTCHA_SITE_KEY ?? '',
  },
  isDev: Boolean(env.DEV),
};

/** True when a CAPTCHA is actually configured; auth forms skip the widget otherwise. */
export const captchaEnabled = config.captcha.provider !== 'none' && Boolean(config.captcha.siteKey);

export default config;
